import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=08dfbcea&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=08dfbcea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dfbcea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08dfbcea')) {
      api.createRecord('08dfbcea', component.options)
    } else {
      api.reload('08dfbcea', component.options)
    }
    module.hot.accept("./ForgottenPassword.vue?vue&type=template&id=08dfbcea&scoped=true&", function () {
      api.rerender('08dfbcea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ForgottenPassword.vue"
export default component.exports